import script from "./TheFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./TheFooter.vue?vue&type=script&setup=true&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=c7a324ec&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7a324ec"]])

export default __exports__